import { c as _c } from "react/compiler-runtime";
interface WorldchainIconProps {
  className?: string;
}
export function WorldIcon(t0) {
  const $ = _c(6);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <circle cx="300" cy="300" r="300" fill="black" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g transform="matrix(1.2994699,0,0,1.2994699,725.31494,727.89368)"><g transform="translate(131.17999,104.74)"><path strokeLinecap="round" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="10" stroke="white" strokeOpacity="1" strokeWidth="35px" d="m 119.067,-87.470001 c 0,0 -145.507001,0.230003 -145.507001,0.230003 C -74.620003,-87.239998 -113.68,-48.18 -113.68,0 c 0,48.18 39.059997,87.239998 87.239999,87.239998 0,0 140.120001,0 140.120001,0" /></g></g>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <g transform="matrix(1.2994699,0,0,1.2994699,643.73987,841.25928)"><path strokeLinecap="round" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="10" stroke="white" strokeOpacity="1" strokeWidth="35px" d="m 2.309,17.5 c 0,0 336.11101,0 336.11101,0" /></g>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <g transform="translate(-99.689875,-99.947068)"><g transform="matrix(1.2367001,0,0,1.2367001,-668.2998,-668.50879)">{t2}{t3}<g transform="matrix(1.2994699,0,0,1.2994699,620.99915,621.3761)"><g transform="translate(186.71001,186.71001)"><path strokeLinecap="round" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="10" stroke="white" strokeOpacity="1" strokeWidth="35px" d="M 0,-169.21001 C 93.452003,-169.21001 169.21001,-93.452003 169.21001,0 169.21001,93.452003 93.452003,169.21001 0,169.21001 -93.452003,169.21001 -169.21001,93.452003 -169.21001,0 -169.21001,-93.452003 -93.452003,-169.21001 0,-169.21001 Z" /></g></g></g></g>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== className) {
    t5 = <svg viewBox="0 0 600 600" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>{t1}{t4}</svg>;
    $[4] = className;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}